import { isPlatformBrowser } from '@angular/common';
import {Inject, Injectable, Optional, PLATFORM_ID} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import { TeamService } from '@app/core/services/team.service';
import { RESPONSE } from '@nguniversal/express-engine/tokens';
import { UrlService } from '@utils/services/url/url.service';
import { Response } from 'express';

@Injectable()
export class TeamAboGuard implements CanActivate {

  constructor(
    @Optional() @Inject(RESPONSE) private serverResponse: Response<any>,
    private teamService: TeamService,
    @Inject(PLATFORM_ID) private platformId,
   ) {}

  public async canActivate(): Promise<boolean> {
    const readableId = this.teamService.currentTeam.readable_id;
    if (isPlatformBrowser(this.platformId)) {
      window.location.href = UrlService.Web + `/abo/subscribe/${readableId})`;
      return false;
    } else {
      this.serverResponse.redirect(UrlService.Web + `/abo/subscribe/${readableId}`);
    }
    return true;
  }
}
